// extracted by mini-css-extract-plugin
export default {"loading":"Logs_loading__qS+jj","logsBox":"Logs_logsBox__SSaS1","log":"Logs_log__PJ0dB","print":"Logs_print__f58Kg","time":"Logs_time__bOrZJ"};